import criterialTemplteContent from 'raw-loader!@/assets/data/CriteriaLevel.ini'
import axios from 'axios'

class CriteriaLevelUtil {
	/**
	 *
	 */
	constructor(paramCotnent, defaultCriterialContent) {
		//加载默认的模板配置。
		this.criterialContent = defaultCriterialContent
		if (paramCotnent) {
			this.criterialContent = paramCotnent
		}

		console.log(this.criterialContent)

		this.criterialObject = this._getPrivateItems(this.criterialContent)
		this.sectionObject = this.parseINIString(this.criterialContent)

		console.log('默认配置', this.sectionObject)

		this._etag = new Date().getTime()
	}

	/**
	 * 替换缺陷类型中的参数。
	 * @param {*} level
	 * @param {*} phase
	 * @param {*} type
	 * @param {*} unit
	 * @param {*} value
	 */
	replaceParams(level, phase, type, unit, value) {
		var paramName = `${level}.${phase}.${type}.${unit}`

		console.log('替换参数值', paramName, value)
		if (paramName in this.sectionObject) {
			this.sectionObject[paramName].Value = value
		}
	}

	/**
	 *
	 */
	getFileBody() {
		var fileBody = []

		var obj = this.sectionObject
		//遍历对象所有属性。
		for (var section in obj) {
			fileBody.push(`[${section}]`)

			for (var p in obj[section]) {
				var value = obj[section][p]
				fileBody.push(`${p}=${value}`)
			}
		}

		return fileBody.join('\r\n')
	}

	/**
	 * 获取所有缺陷类型。
	 * @param {*} level
	 * @param {*} phase
	 */
	getDefectTypes(level, phase) {
		var array = this.criterialObject
			.filter(t => t.level.value == level && t.phase.value == phase)
			.map(t => {
				return {
					value: t.value,
					display: t.display,
				}
			})

		const result = []
		array.forEach((element, i) => {
			var index = result.findIndex(t => t.value == element.value)
			if (index == -1) {
				result.push({
					...element,
				})
			}
		})

		return result
	}

	/**
	 * 获取所有检测等级。
	 */
	getLevels() {
		var levels = this.criterialObject.map(t => {
			return {
				value: t.level.value,
				display: t.level.display,
			}
		})

		const result = []
		levels.forEach((element, i) => {
			var index = result.findIndex(t => t.value == element.value)
			if (index == -1) {
				result.push({
					...element,
				})
			}
		})

		return result
	}

	/**
	 * 获取所有印次。
	 */
	getPhases() {
		var array = this.criterialObject.map(t => {
			return {
				value: t.phase.value,
				display: t.phase.display,
			}
		})

		const result = []
		array.forEach((element, i) => {
			var index = result.findIndex(t => t.value == element.value)
			if (index == -1) {
				result.push({
					...element,
				})
			}
		})

		return result
	}

	/**
	 * 获取所有缺陷配置。
	 * @param {*} paramCotnent
	 */
	getItems(paramCotnent) {
		if (!paramCotnent) {
			paramCotnent = this.criterialContent
		}

		var items = this._getPrivateItems(paramCotnent)
		return items
	}

	/**
	 *
	 * @param {*} criterialContent
	 */
	_getPrivateItems = criterialContent => {
		var obj = this.parseINIString(criterialContent)
		var array = []

		//获取所有检测等级。
		var levelList = obj['LevelList'].Value.split(',')
		//获取检测等级显示名称。
		levelList.forEach((levelStr, i) => {
			// if (levelDisplayName != '未知等级') {
			// 	var levelDisplayName = obj[levelStr].Display
			// 	console.log(levelDisplayName)
			// }

			var levelValue = obj[levelStr].Value
			var levelDisplayName = obj[levelStr].Display

			//获取检测等级下面所有的印次。
			var phaseList = obj[levelStr + '.PhaseList'].Value.split(',')
			phaseList.forEach(phaseItem => {
				//获取印次下面的所有的缺陷类型。
				var defectTypes = obj[[levelStr, phaseItem, 'DefectTypeList'].join('.')].Value.split(',')
				//console.log('缺陷类型：', defectTypes)

				var phaseValue = obj[`${levelStr}.${phaseItem}`].Value
				var phaseDisplay = obj[`${levelStr}.${phaseItem}`].Display

				//获取缺陷类型下面所有的单位。
				defectTypes.forEach(defectTypeItem => {
					var unitValue = obj[[levelStr, phaseItem, defectTypeItem].join('.')].Value
					var display = obj[[levelStr, phaseItem, defectTypeItem].join('.')].Display
					var units = [unitValue]
					if (unitValue.indexOf(',') > -1) {
						units = unitValue.split(',')
					}

					var newObject = {
						level: {
							value: levelValue,
							display: levelDisplayName,
							name: levelStr,
						},
						phase: {
							value: phaseValue,
							display: phaseDisplay,
						},
						value: defectTypeItem,
						display: display,
						units: [],
					}

					var unit_list = []
					units.forEach(unitStr => {
						var p = [levelStr, phaseItem, defectTypeItem, unitStr].join('.')
						var min = parseInt(obj[p].Min)
						var max = parseInt(obj[p].Max)
						var unitName = obj[p].UnitName
						var display = obj[p].Display
						var value = parseInt(obj[p].Value)

						if (min < 5) min = 5
						if (value < 5) value = 5
						unit_list.push({
							id: unitStr,
							value,
							reverseValue: max - value,
							display,
							min,
							max,
							unitName,
						})
					})
					newObject.units = unit_list

					array.push(newObject)
				})
			})
		})

		return array
	}

	/**
	 * 转换Ini文件。
	 * @param {*} data
	 */
	parseINIString(data) {
		if (!data) {
			return {}
		}
		var regex = {
			section: /^\[\s*\s*([^]*)\s*\]\s*$/,
			param: /^\s*([\w\\.\-\\_]+)\s*=\s*(.*?)\s*$/,
			comment: /^\s*;.*$/,
		}
		var value = {}
		var lines = data.split(/\r\n|\r|\n/)
		var section = null
		lines.forEach(function(line) {
			var match = null
			if (regex.comment.test(line)) {
				return
			} else if (regex.param.test(line)) {
				match = line.match(regex.param)
				if (section) {
					value[section][match[1]] = match[2]
				} else {
					value[match[1]] = match[2]
				}
			} else if (regex.section.test(line)) {
				match = line.match(regex.section)
				value[match[1]] = {}
				section = match[1]
			} else if (line.length == 0 && section) {
				section = null
			}
		})
		return value
	}
}

export default CriteriaLevelUtil
